'use strict'

const pump = require('pump')
const concat = require('concat-stream')

/*
  Concatenate a stream to a single value.
*/
function streamToValue (response, callback) {
  pump(
    response,
    concat((data) => callback(null, data)),
    (err) => {
      if (err) {
        callback(err)
      }
    })
}

module.exports = streamToValue



//////////////////
// WEBPACK FOOTER
// ./node_modules/ipfs-api/src/utils/stream-to-value.js
// module id = GZwi
// module chunks = 0